// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bbf4e6b46a304d18b873","655":"6a2fe576a9d3122ce698"}[chunkId] + ".js";
};